import type { RootState } from '@redux/store'

export const budgetSelector = (state: RootState) => state.budget
